import React, { Fragment, useEffect, useState, useRef, RefObject  } from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, useDispatch } from 'react-redux';
import AccountBalanceWallet from "@mui/icons-material/AccountBalanceWallet"; 
import translate from '../../i18n';
import { useFormik } from "formik";
import { RootState } from "../../store/ducks";
import Actions from "../../store/ducks/simuladorPrevidencia";
import { moneyToNumber, formatMoney } from "../../utils";
import CurrencyFormat from "react-currency-format";
import ErrorLabel from "../../components/ErrorLabel";
import Slider from "@mui/material/Slider";
import Chart from "react-apexcharts";
import { useLocation } from "react-router-dom"; 
import $ from "jquery";

interface Props {
  simuladorPrevidencia: {
    formulario: {
      step: number;
      tipo: string;
      idade: string;
      idadeAposentadoria: string;
      salarioParticipacao: string;
      fatorContribuicao: number;
      contribuicaoBasica: string;
      creditoMigracao: string;
      concordo: string;
      percentualPagamentoUnico: number;
      percentualInicialAposentadoria: number;
    };
    contribuicaoMaxima: string;
    contribuicaoBasica: string,
    resultado: boolean;
    simulacao: {
      idadeAtual: "";
      taxaJuros: "";
      taxaAdministracao: "";
      taxaCarregamento: "";
      valorUp: "";
      valorContribuicaoMensal: "";
      valorContribuicaoAdicional: "";
      valorMigracao: "";
      idadeAposentadoria: "";
      tempoContribuicao: "";
      valorBeneficio: "";
      anosBeneficio: "";
      beneficioInicial: "";
      valorUltimoBeneficio: "";
      saldoAcumulado: "";
      percentualPagamentoUnico: "";
      pagamentoUnico: "";
      valorTotalContribuicaoParticipante: "";
      valorTotalContribuicaoPatrocinadora: "";
      valorRentabilidade: "";
      percContribuicaoParticipante: 0;
      percContribuicaoPatrocinadora: 0;
      percRentabilidade: 0;
      percAporte: 0;
      valorSaldoAtual03: "";
      valorSaldoAtual05: "";
      valorSaldoAtual10: "";
      valorSaldoAtual20: "";
    };
  };
  consultarContribuicaoMaximaRequest: Function;
  consultarSimulacaoRequest: Function;
  consultarContribuicaoBasica: Function;
}


const SimuladorPrevidencia: React.FC<Props> = ({
  simuladorPrevidencia,
  consultarContribuicaoMaximaRequest,
  consultarSimulacaoRequest,
  consultarContribuicaoBasica,
}) => {

  const location = useLocation();

  const inputIdadeAposentadoria =
    React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const inputIdade =
    React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const inputSalarioParticipacao =
    React.useRef() as React.MutableRefObject<CurrencyFormat>;
  const inputFatorContribuicao =
    React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const inputCreditoMigracao =
    React.useRef() as React.MutableRefObject<HTMLInputElement>;


  const params = new URLSearchParams(location.search);
  const tipo = params.get("tipo");
  let creditoMigracao: any = params.get("creditoMigracao");
  if (creditoMigracao){
    creditoMigracao = formatMoney(parseFloat(creditoMigracao));
  }
  const [step, setStep] = useState(1);
  const [tipoSimulacao, setTipoSimulacao] = useState(
    tipo ? (tipo == "A" ? "ativo" : "assistido") : "ativo"
  );
  const [alterarDados, setAlterarDados] = useState(false);
  const [percentualPagamentoUnico, setPercentualPagamentoUnico] =
    useState(10);
  const [percentualPagamentoUnicoRequest, setPercentualPagamentoUnicoRequest] =
    useState(10);
  const [percentualInicialAposentadoria, setPercentualInicialAposentadoria] =
    useState(0.1);
  const [percentualInicialAposentadoriaRequest, setPercentualInicialAposentadoriaRequest] =
    useState(0.1);
  const [series, setSeries] = useState([25, 25, 25, 25]);

  const [options, setOptions] = useState({
    chart: {
      width: 380,
      redrawOnParentResize: false,
      redrawOnWindowResize: false,
    },
    yaxis: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      y: {
        formatter: function (value: any) {
          return formatMoney(value) + "%";
        },
        title: {
          formatter: (seriesName: any) => "",
        },
      },
      x: {
        formatter: function (value: any) {
          return "";
        },
      },
      title: {
        formatter: function (seriesName: any) {
          return ". ";
        },
      },
    },
    colors: ["#08b2a1", "#1772de", "#fd7582", "#8e8cea"],
    legend: {
      show: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  const formik = useFormik({
    initialValues: {
      tipo: tipo ? (tipo == "A" ? "ativo" : "assistido") : "ativo",
      idade: "",
      idadeAposentadoria: "", 
      salarioParticipacao: "",
      fatorContribuicao: "",
      contribuicaoBasica: "",
      creditoMigracao: creditoMigracao ? creditoMigracao : "",
      concordo: "false",
      percentualPagamentoUnico: 10,
      percentualInicialAposentadoria: 0.1,
      contribuicaoMaxima: "",
      step: 1,
      error: "",
      resultado: false,
      simulacao: {
        idadeAtual: "",
        taxaJuros: "",
        taxaAdministracao: "",
        taxaCarregamento: "",
        valorUp: "",
        valorContribuicaoMensal: "",
        valorContribuicaoAdicional: "",
        valorMigracao: "",
        idadeAposentadoria: "",
        tempoContribuicao: "",
        valorBeneficio: "",
        anosBeneficio: "",
        beneficioInicial: "",
        valorUltimoBeneficio: "",
        saldoAcumulado: "",
        percentualPagamentoUnico: "",
        pagamentoUnico: "",
        valorTotalContribuicaoParticipante: "",
        valorTotalContribuicaoPatrocinadora: "",
        valorRentabilidade: "",
        percContribuicaoParticipante: 0,
        percContribuicaoPatrocinadora: 0,
        percRentabilidade: 0,
        percAporte: 0,
        valorSaldoAtual03: "",
        valorSaldoAtual05: "",
        valorSaldoAtual10: "",
        valorSaldoAtual20: "",
      },
    },
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {},
  });

  useEffect(() => {
    atualizarCamposNaTela();
  }, [simuladorPrevidencia.contribuicaoMaxima]);

  function atualizarCamposNaTela() {
    formik.setFieldValue(
      "contribuicaoMaxima",
      simuladorPrevidencia.contribuicaoMaxima
    );

    if (
      simuladorPrevidencia.contribuicaoMaxima &&
      fatorContribuicaoValido(formik.values.fatorContribuicao)
    ){
      let request = {
        contribuicaoMaxima: moneyToNumber(simuladorPrevidencia.contribuicaoMaxima),
        fatorContribuicao: formik.values.fatorContribuicao,
      };

       consultarContribuicaoBasica(request);
    }
     
   
  }

    useEffect(() => {
      atualizarContribuicaoBasica();
    }, [simuladorPrevidencia.contribuicaoBasica]);

    useEffect(() => {
      if (formik.values.simulacao.taxaJuros) {
        calcularSimulacao();
      }
    }, [percentualInicialAposentadoriaRequest]);
  
    useEffect(() => {
     
      if (tipoSimulacao == "ativo" && step == 1) {
        inputIdade.current.focus();
      } else if (tipoSimulacao == "assistido" && step == 1) {
        $("#creditoMigracaoInicial").focus();
      } else if (tipoSimulacao == "ativo" && step == 2) {
        inputIdadeAposentadoria.current.focus();
      } else if (tipoSimulacao == "ativo" && step == 3) {
        $("#salarioParticipacao").focus();
      } else if (tipoSimulacao == "ativo" && step == 4) {
        inputFatorContribuicao.current.focus();
      } else if (tipoSimulacao == "ativo" && step == 5) {
        $("#creditoMigracao").focus();
      }
    }, [step, tipoSimulacao]);

    useEffect(() => {
      if (formik.values.simulacao.taxaJuros) {
        calcularSimulacao();
      }
    }, [percentualPagamentoUnicoRequest]);

    useEffect(() => {
      let salarioParticipacao = moneyToNumber(formik.values.salarioParticipacao);
      if (salarioParticipacao){
        consultarContribuicaoMaximaRequest(salarioParticipacao);
      }
    }, [formik.values.salarioParticipacao]);

  function atualizarContribuicaoBasica() {
    
    formik.setFieldValue(
      "contribuicaoBasica",
      simuladorPrevidencia.contribuicaoBasica
    );

  }

  useEffect(() => {
    atualizarResultadoSimulacao();
  }, [simuladorPrevidencia.simulacao]);

  function atualizarResultadoSimulacao() {

    if (simuladorPrevidencia.simulacao.percContribuicaoPatrocinadora){
      let series: number[] = [
        simuladorPrevidencia.simulacao.percContribuicaoParticipante,
        simuladorPrevidencia.simulacao.percContribuicaoPatrocinadora,
        simuladorPrevidencia.simulacao.percAporte,
        simuladorPrevidencia.simulacao.percRentabilidade,
      ];
      setSeries(series)
    }
    formik.setFieldValue(
      "simulacao.idadeAtual",
      simuladorPrevidencia.simulacao.idadeAtual
    );
    formik.setFieldValue(
      "simulacao.taxaJuros",
      simuladorPrevidencia.simulacao.taxaJuros
    );
    formik.setFieldValue(
      "simulacao.taxaAdministracao",
      simuladorPrevidencia.simulacao.taxaAdministracao
    );
    formik.setFieldValue(
      "simulacao.taxaCarregamento",
      simuladorPrevidencia.simulacao.taxaCarregamento
    );
    formik.setFieldValue(
      "simulacao.valorUp",
      simuladorPrevidencia.simulacao.valorUp
    );
    formik.setFieldValue(
      "simulacao.valorContribuicaoMensal",
      simuladorPrevidencia.simulacao.valorContribuicaoMensal
    );
    formik.setFieldValue(
      "simulacao.valorContribuicaoAdicional",
      simuladorPrevidencia.simulacao.valorContribuicaoAdicional
    );
    formik.setFieldValue(
      "simulacao.valorMigracao",
      simuladorPrevidencia.simulacao.valorMigracao
    );
    formik.setFieldValue(
      "simulacao.idadeAposentadoria",
      simuladorPrevidencia.simulacao.idadeAposentadoria
    );
    formik.setFieldValue(
      "simulacao.tempoContribuicao",
      simuladorPrevidencia.simulacao.tempoContribuicao
    );
    formik.setFieldValue(
      "simulacao.valorBeneficio",
      simuladorPrevidencia.simulacao.valorBeneficio
    );
    formik.setFieldValue(
      "simulacao.anosBeneficio",
      simuladorPrevidencia.simulacao.anosBeneficio
    );
    formik.setFieldValue(
      "simulacao.beneficioInicial",
      simuladorPrevidencia.simulacao.beneficioInicial
    );
    formik.setFieldValue(
      "simulacao.valorUltimoBeneficio",
      simuladorPrevidencia.simulacao.valorUltimoBeneficio
    );
    formik.setFieldValue(
      "simulacao.saldoAcumulado",
      simuladorPrevidencia.simulacao.saldoAcumulado
    );
    formik.setFieldValue(
      "simulacao.percentualPagamentoUnico",
      simuladorPrevidencia.simulacao.percentualPagamentoUnico
    );
    formik.setFieldValue(
      "simulacao.pagamentoUnico",
      simuladorPrevidencia.simulacao.pagamentoUnico
    );
    formik.setFieldValue(
      "simulacao.valorTotalContribuicaoParticipante",
      simuladorPrevidencia.simulacao.valorTotalContribuicaoParticipante
    );
    formik.setFieldValue(
      "simulacao.valorTotalContribuicaoPatrocinadora",
      simuladorPrevidencia.simulacao.valorTotalContribuicaoPatrocinadora
    );
    formik.setFieldValue(
      "simulacao.valorRentabilidade",
      simuladorPrevidencia.simulacao.valorRentabilidade
    );
    formik.setFieldValue(
      "simulacao.percContribuicaoParticipante",
      simuladorPrevidencia.simulacao.percContribuicaoParticipante
    );
    formik.setFieldValue(
      "simulacao.percContribuicaoPatrocinadora",
      simuladorPrevidencia.simulacao.percContribuicaoPatrocinadora
    );
    formik.setFieldValue(
      "simulacao.percRentabilidade",
      simuladorPrevidencia.simulacao.percRentabilidade
    );
    formik.setFieldValue(
      "simulacao.percAporte",
      simuladorPrevidencia.simulacao.percAporte
    );
    formik.setFieldValue(
      "simulacao.valorSaldoAtual03",
      simuladorPrevidencia.simulacao.valorSaldoAtual03
    );
    formik.setFieldValue(
      "simulacao.valorSaldoAtual05",
      simuladorPrevidencia.simulacao.valorSaldoAtual05
    );
    formik.setFieldValue(
      "simulacao.valorSaldoAtual10",
      simuladorPrevidencia.simulacao.valorSaldoAtual10
    );
    formik.setFieldValue(
      "simulacao.valorSaldoAtual20",
      simuladorPrevidencia.simulacao.valorSaldoAtual20
    );

  }

  function fatorContribuicaoValido(valor: any) {
    let fatorContribuicaoNumerico = valor
      ? valor
      : formik.values.fatorContribuicao;

    return (
      fatorContribuicaoNumerico > 0 &&
      fatorContribuicaoNumerico <= 100 &&
      fatorContribuicaoNumerico % 10 == 0
    );
  }

  const handleSliderChangeCommitted = (event: any, newValue: any) => {
    setPercentualPagamentoUnicoRequest(newValue);
  };

  const handleSliderChange = (event: any, newValue: any) => {
    setPercentualPagamentoUnico(newValue);
  };

  const handlePercentualAposentadoriaSliderChangeCommitted = (
    event: any,
    newValue: any
  ) => {
    setPercentualInicialAposentadoriaRequest(newValue);
  };

  
  const handlePercentualAposentadoriaSliderChange = (event: any, newValue: any) => {
    setPercentualInicialAposentadoria(newValue);
  };

  function handleTipoChange(event: any) {
    formik.handleChange(event);
    setStep(1);
    setTipoSimulacao(event.target.value);
    formik.values.step = 1;
  }

  function handleSalarioParticipacaoChange(event: any) {
    formik.handleChange(event);
    
  }

  function handleIdadeAposentadoriaChange(event: any) {
    formik.handleChange(event);
    let idadeAposentadoria = event.target.value;
    if (idadeAposentadoria < 45 || idadeAposentadoria > 100) {
      formik.values.error = translate.t(
                    "app.mensagem.validacao.idadeAposentadoriaMinima"
                  )
      
    } else {
      formik.values.error = ""
    }
  }

  function handleFatorContribuicaoChange(event: any) {
    formik.handleChange(event);
    let fatorContribuicao = event.target.value;
    if (fatorContribuicaoValido(fatorContribuicao)) {
      let request = {
        contribuicaoMaxima: moneyToNumber(
          simuladorPrevidencia.contribuicaoMaxima
        ),
        fatorContribuicao: fatorContribuicao,
      };

      consultarContribuicaoBasica(request);
    formik.values.error =
      "";
    } else {
      formik.setFieldValue("contribuicaoBasica", "");
      formik.values.error = translate.t(
        "app.mensagem.validacao.fatorContribuicaoInvalido"
      );
    }
  }

  function alterarDadosSimulacao(event: any) {
    event.preventDefault();
    if (alterarDados) {
      setAlterarDados(false);
      verResultado(event);
    } else {
      setAlterarDados(true);
    }
  }

  function avancar(event: any) {
    event.preventDefault();
    let stepAtual = step;
    stepAtual = stepAtual + 1;
    setStep(stepAtual);
    formik.values.step = stepAtual;
    
    if (stepAtual == 4) {
    } else if (stepAtual == 6) {
      verResultado(event);
      window.scrollTo(0, 0);

    }
  }

  function calcularSimulacao() {
    let request = {
      idadeInicial: formik.values.tipo == "ativo" ? formik.values.idade : 0,
      idadeFinal:
        formik.values.tipo == "ativo" ? formik.values.idadeAposentadoria : 0,
      valorRemuneracao:
        formik.values.tipo == "ativo"
          ? moneyToNumber(formik.values.salarioParticipacao)
          : 0,
      valorAporteInicial: 0,
      valorMigracao: moneyToNumber(formik.values.creditoMigracao),
      tipoSimulacao: formik.values.tipo == "ativo" ? "A" : "S",
      percentualContribuicao:
        formik.values.tipo == "ativo" ? formik.values.fatorContribuicao : 0,
      percentualSaldoBeneficio: percentualInicialAposentadoria,
      percentualPagamentoUnico: percentualPagamentoUnico,
    };
    consultarSimulacaoRequest(request);
  }

  function verResultado(event: any) {
    event.preventDefault();
    calcularSimulacao();
  }

  function valuetext(value: number) {
    return `${value}%`;
  }

  return (
    <Fragment>
      <main>
        <div className="wrapper">
          <div className="title">
            <span>
              <AccountBalanceWallet className="material-icons" />
            </span>
            <h2>{`${translate.t(
              "app.tela.simulacaoPrevidenciaCDPuro.titulo"
            )}`}</h2>
          </div>
          <div
            className={
              (!formik.values.simulacao.idadeAtual &&
                formik.values.tipo == "ativo") ||
              (!formik.values.simulacao.anosBeneficio &&
                formik.values.tipo == "assistido")
                ? "chair1"
                : "chair1 hyde"
            }
          >
            <form>
              <div className="choice1">
                <label
                  className={
                    formik.values.tipo == "ativo" ? "radio checked" : "radio"
                  }
                >
                  {`${translate.t(
                    "app.tela.simulacaoPrevidenciaCDPuro.label.ativo"
                  )}`}{" "}
                  <input
                    type="radio"
                    name="tipo"
                    checked={formik.values.tipo === "ativo"}
                    onChange={handleTipoChange}
                    value="ativo"
                  />
                </label>
                <label
                  className={
                    formik.values.tipo == "assistido"
                      ? "radio checked"
                      : "radio"
                  }
                >
                  <input
                    type="radio"
                    name="tipo"
                    onChange={handleTipoChange}
                    checked={formik.values.tipo === "assistido"}
                    value="assistido"
                  />{" "}
                  {`${translate.t(
                    "app.tela.simulacaoPrevidenciaCDPuro.label.assistido"
                  )}`}
                </label>
              </div>

              <div
                className={formik.values.tipo == "ativo" ? "ativ" : "ativ hyde"}
              >
                <div className="step1">
                  <p>
                    1 ----
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.infoIdadeAtual"
                    )}`}
                  </p>
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.idadeAtual"
                    )}`}
                    <input
                      type="number"
                      autoFocus
                      name="idade"
                      maxLength={3}
                      min={1}
                      ref={inputIdade}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.idade}
                    />
                  </label>
                </div>

                <div className={step >= 2 ? "step2 on" : "step2"}>
                  <p>
                    2 ----
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.infoIdadeAposentadoria"
                    )}`}
                    <i>
                      ?
                      <span className="tooltip">
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.tooltipIdadeAposentadoria"
                        )}`}
                      </span>
                    </i>
                  </p>
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.idadeAposentadoria"
                    )}`}
                    <input
                      type="number"
                      name="idadeAposentadoria"
                      ref={inputIdadeAposentadoria}
                      maxLength={3}
                      min={45}
                      onChange={handleIdadeAposentadoriaChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.idadeAposentadoria}
                    />
                  </label>
                </div>

                <div className={step >= 3 ? "step3 on" : "step3"}>
                  <p>
                    3 ----
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.infoSalarioParticipacao"
                    )}`}
                    <i>
                      ?
                      <span className="tooltip">
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.tooltipSalarioParticipacao"
                        )}`}
                      </span>
                    </i>
                  </p>
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.salarioParticipacao"
                    )}`}

                    <CurrencyFormat
                      name="salarioParticipacao"
                      id="salarioParticipacao"
                      onBlur={formik.handleBlur}
                      ref={inputSalarioParticipacao}
                      onChange={handleSalarioParticipacaoChange}
                      value={formik.values.salarioParticipacao}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </label>
                </div>

                <div className={step >= 4 ? "step4 on" : "step4"}>
                  <p>
                    4 ----
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.infoFatorContribuicao"
                    )}`}
                    <i>
                      ?
                      <span className="tooltip">
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.tooltipFatorContribuicao"
                        )}`}
                      </span>
                    </i>
                  </p>
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoMaxima"
                    )}`}
                    <input
                      type="text"
                      name="contribuicaoMaxima"
                      disabled
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contribuicaoMaxima}
                    />
                  </label>
                  <br />
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.fatorContribuicao"
                    )}`}
                    <input
                      type="number"
                      name="fatorContribuicao"
                      min="0"
                      max="100"
                      maxLength={3}
                      step={10}
                      ref={inputFatorContribuicao}
                      onChange={handleFatorContribuicaoChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.fatorContribuicao}
                    />
                  </label>
                  <br />
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoBasica"
                    )}`}
                    <input
                      type="text"
                      name="contribuicaoBasica"
                      disabled
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.contribuicaoBasica}
                    />
                  </label>
                </div>

                <div
                  className={
                    (step == 5 && formik.values.tipo == "ativo") ||
                    (step == 1 && formik.values.tipo == "assistido")
                      ? "step5 on"
                      : "step5"
                  }
                >
                  <p>
                    5 ----
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.infoCreditoMigracao"
                    )}`}
                    <i>
                      ?
                      <span className="tooltip">
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.tooltipValorMigracao"
                        )}`}
                      </span>
                    </i>
                  </p>
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.creditoMigracao"
                    )}`}
                    <CurrencyFormat
                      name="creditoMigracao"
                      id="creditoMigracao"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.creditoMigracao}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </label>
                </div>

                <ErrorLabel error={formik.values.error} />

                <div
                  className={
                    step == 5 && formik.values.tipo == "ativo"
                      ? "step6 on"
                      : "step6"
                  }
                >
                  <h5>{`${translate.t(
                    "app.tela.simulacaoPrevidenciaCDPuro.label.termosUso"
                  )}`}</h5>
                  <p>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.termosUsoTexto"
                    )}`}
                  </p>

                  <div className="choice">
                    <label
                      className={
                        formik.values.concordo == "true"
                          ? "radio checked"
                          : "radio"
                      }
                    >
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.concordo"
                      )}`}
                      <input
                        type="radio"
                        name="concordo"
                        onChange={formik.handleChange}
                        checked={formik.values.concordo === "true"}
                        value="true"
                      />
                    </label>
                    <label
                      className={
                        formik.values.concordo == "false"
                          ? "radio checked"
                          : "radio"
                      }
                    >
                      <input
                        type="radio"
                        name="concordo"
                        onChange={formik.handleChange}
                        checked={formik.values.concordo === "false"}
                        value="false"
                        required
                      />{" "}
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.naoConcordo"
                      )}`}
                    </label>
                  </div>
                </div>

                <input
                  type="submit"
                  onClick={(event) => avancar(event)}
                  value={
                    step <= 4
                      ? "Próximo (" + (step + 1) + " de 5)"
                      : "VER RESULTADO"
                  }
                  disabled={
                    (formik.values.idade == "" &&
                      step == 1 &&
                      formik.values.tipo == "ativo") ||
                    ((formik.values.creditoMigracao == "" ||
                      formik.values.concordo == "false") &&
                      step == 1 &&
                      formik.values.tipo == "assistido") ||
                    ((formik.values.idadeAposentadoria == "" ||
                      parseInt(formik.values.idadeAposentadoria) < 45 ||
                      parseInt(formik.values.idadeAposentadoria) > 100) &&
                      step == 2) ||
                    (formik.values.salarioParticipacao == "" && step == 3) ||
                    (!fatorContribuicaoValido("") && step == 4) ||
                    ((formik.values.creditoMigracao == "" ||
                      formik.values.concordo == "false") &&
                      step == 5) ||
                    (step == 5 &&
                      (formik.values.concordo == "false" ||
                        formik.values.creditoMigracao == ""))
                  }
                />
              </div>
              <div
                className={
                  !formik.values.simulacao.anosBeneficio &&
                  formik.values.tipo == "assistido"
                    ? "ativ"
                    : "ativ hyde"
                }
              >
                <div className="stepunic1">
                  <p>
                    1 ----
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.infoCreditoMigracao"
                    )}`}
                    <i>
                      ?
                      <span className="tooltip">
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.tooltipValorMigracao"
                        )}`}
                      </span>
                    </i>
                  </p>
                  <label>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.creditoMigracao"
                    )}`}
                    <CurrencyFormat
                      name="creditoMigracao"
                      id="creditoMigracaoInicial"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.creditoMigracao}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </label>
                </div>

                <div className="stepunic2">
                  <h5>{`${translate.t(
                    "app.tela.simulacaoPrevidenciaCDPuro.label.termosUso"
                  )}`}</h5>
                  <p>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.termosUsoTexto"
                    )}`}
                  </p>

                  <div className="choice">
                    <label
                      className={
                        formik.values.concordo == "true"
                          ? "radio checked"
                          : "radio"
                      }
                    >
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.concordo"
                      )}`}
                      <input
                        type="radio"
                        name="concordo"
                        onChange={formik.handleChange}
                        checked={formik.values.concordo === "true"}
                        value="true"
                      />
                    </label>
                    <label
                      className={
                        formik.values.concordo == "false"
                          ? "radio checked"
                          : "radio"
                      }
                    >
                      <input
                        type="radio"
                        name="concordo"
                        onChange={formik.handleChange}
                        checked={formik.values.concordo === "false"}
                        value="false"
                        required
                      />{" "}
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.naoConcordo"
                      )}`}
                    </label>
                  </div>
                </div>

                <input
                  type="submit"
                  value="Resultado"
                  onClick={(event) => verResultado(event)}
                  disabled={
                    formik.values.tipo == "assistido" &&
                    (formik.values.creditoMigracao == "" ||
                      formik.values.concordo == "false")
                  }
                />
              </div>
            </form>
          </div>

          <div
            className={
              formik.values.simulacao.anosBeneficio ? "chair2" : "chair2 hyde"
            }
          >
            <section className="box-orange">
              <div className="title-box-orange">
                <h2>{`${translate.t(
                  "app.tela.simulacaoPrevidenciaCDPuro.label.resultadoSimulacao"
                )}`}</h2>
              </div>

              <div className="group-of-oranges">
                <div className="first orange">
                  <p>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.saldoAcumuladoAposentadoria"
                    )}`}
                    :
                  </p>
                  <p className="numbers">
                    R${" "}
                    {formatMoney(
                      parseFloat(formik.values.simulacao.saldoAcumulado)
                    )}
                  </p>
                </div>

                <div className="vertical line a"></div>

                <div className="secound orange">
                  <p>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.aposentadoriaMensal"
                    )}`}
                    :
                  </p>
                  <p className="numbers">
                    R${" "}
                    {formatMoney(
                      parseFloat(formik.values.simulacao.valorBeneficio)
                    )}
                  </p>
                </div>

                <div className="vertical line b"></div>

                <div className="third orange">
                  <p>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.periodoRecebimentoAposentadoria"
                    )}`}
                    :
                  </p>
                  <p className="numbers">
                    {formik.values.simulacao.anosBeneficio} anos
                  </p>
                </div>
              </div>
            </section>

            <section className="group-of-white-blocks">
              <div className="group-three-firsts-blocks">
                <div>
                  <div
                    className={
                      alterarDados
                        ? "hyde"
                        : formik.values.tipo == "ativo"
                        ? "first-block"
                        : "first-block assisti1"
                    }
                  >
                    <h2>
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.seusDados"
                      )}`}
                      :
                    </h2>

                    <div
                      className={
                        formik.values.tipo == "ativo"
                          ? "estatistics-first-block"
                          : "estatistics-first-block hyde"
                      }
                    >
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.idadeAtual"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        {formik.values.idade}
                      </p>
                    </div>
                    <div
                      className={
                        formik.values.tipo == "ativo"
                          ? "estatistics-first-block"
                          : "estatistics-first-block hyde"
                      }
                    >
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.idadeAposentadoria"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        {formik.values.idadeAposentadoria}
                      </p>
                    </div>
                    <div
                      className={
                        formik.values.tipo == "ativo"
                          ? "estatistics-first-block"
                          : "estatistics-first-block hyde"
                      }
                    >
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.salarioParticipacao"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        {" "}
                        <span>R$</span> {formik.values.salarioParticipacao}
                      </p>
                    </div>
                    <div
                      className={
                        formik.values.tipo == "ativo"
                          ? "estatistics-first-block"
                          : "estatistics-first-block hyde"
                      }
                    >
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoMaxima"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        <span>R$</span> {formik.values.contribuicaoMaxima}
                      </p>
                    </div>
                    <div
                      className={
                        formik.values.tipo == "ativo"
                          ? "estatistics-first-block"
                          : "estatistics-first-block hyde"
                      }
                    >
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.fatorContribuicao"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        {formik.values.fatorContribuicao}%
                      </p>
                    </div>
                    <div
                      className={
                        formik.values.tipo == "ativo"
                          ? "estatistics-first-block"
                          : "estatistics-first-block hyde"
                      }
                    >
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoBasica"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        <span>R$</span> {formik.values.contribuicaoBasica}
                      </p>
                    </div>
                    <div className="estatistics-first-block">
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.creditoMigracao"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        <span>R$</span> {formik.values.creditoMigracao}
                      </p>
                    </div>

                    <div className="button-first ">
                      <button
                        className="button-orange btnsd"
                        onClick={(event) => alterarDadosSimulacao(event)}
                      >
                        {`${translate.t("app.botao.alterarDados")}`}
                      </button>
                    </div>
                  </div>

                  <div
                    className={!alterarDados ? "hyde" : "first-block auther"}
                  >
                    <h2>
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.alterarDados"
                      )}`}
                      :
                    </h2>

                    <form>
                      <div
                        className={
                          formik.values.tipo == "ativo"
                            ? "estatistics-first-block"
                            : "estatistics-first-block hyde"
                        }
                      >
                        <label>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.idadeAtual"
                          )}`}
                          <input
                            className="first-white-group-numbers"
                            type="number"
                            name="idade"
                            maxLength={3}
                            min={1}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.idade}
                          />
                        </label>
                      </div>
                      <div
                        className={
                          formik.values.tipo == "ativo"
                            ? "estatistics-first-block"
                            : "estatistics-first-block hyde"
                        }
                      >
                        <label>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.idadeAposentadoria"
                          )}`}
                          <input
                            className="first-white-group-numbers"
                            type="number"
                            name="idadeAposentadoria"
                            maxLength={3}
                            min={45}
                            onChange={handleIdadeAposentadoriaChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.idadeAposentadoria}
                          />
                        </label>
                      </div>
                      <div
                        className={
                          formik.values.tipo == "ativo"
                            ? "estatistics-first-block"
                            : "estatistics-first-block hyde"
                        }
                      >
                        <label>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.salarioParticipacao"
                          )}`}
                          <CurrencyFormat
                            className="first-white-group-numbers"
                            name="salarioParticipacao"
                            onBlur={formik.handleBlur}
                            onChange={handleSalarioParticipacaoChange}
                            value={formik.values.salarioParticipacao}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </label>
                      </div>
                      <div
                        className={
                          formik.values.tipo == "ativo"
                            ? "estatistics-first-block"
                            : "estatistics-first-block hyde"
                        }
                      >
                        <label>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoMaxima"
                          )}`}
                          <input
                            className="first-white-group-numbers"
                            type="text"
                            name="contribuicaoMaxima"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.contribuicaoMaxima}
                            disabled
                          />
                        </label>
                      </div>
                      <div
                        className={
                          formik.values.tipo == "ativo"
                            ? "estatistics-first-block"
                            : "estatistics-first-block hyde"
                        }
                      >
                        <label>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.fatorContribuicao"
                          )}`}
                          <input
                            className="first-white-group-numbers"
                            type="number"
                            name="fatorContribuicao"
                            min="0"
                            max="100"
                            step={10}
                            maxLength={3}
                            onChange={handleFatorContribuicaoChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.fatorContribuicao}
                          />
                        </label>
                      </div>
                      <div
                        className={
                          formik.values.tipo == "ativo"
                            ? "estatistics-first-block"
                            : "estatistics-first-block hyde"
                        }
                      >
                        <label>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoBasica"
                          )}`}
                          <input
                            className="first-white-group-numbers"
                            type="text"
                            name="contribuicaoBasica"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.contribuicaoBasica}
                            disabled
                          />
                        </label>
                      </div>
                      <div className="estatistics-first-block">
                        <label>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.creditoMigracao"
                          )}`}
                          <input
                            className="first-white-group-numbers"
                            type="text"
                          />
                          <CurrencyFormat
                            className="first-white-group-numbers"
                            name="creditoMigracao"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.creditoMigracao}
                            thousandSeparator="."
                            decimalSeparator=","
                            decimalScale={2}
                            fixedDecimalScale={true}
                          />
                        </label>
                      </div>
                      <ErrorLabel error={formik.values.error} />
                      <div className="button-first">
                        <button
                          className="button-orange"
                          disabled={formik.values.error != ""}
                          onClick={(event) => alterarDadosSimulacao(event)}
                        >{`${translate.t("app.botao.confirmar")}`}</button>
                      </div>
                    </form>
                  </div>
                  <div
                    className={
                      formik.values.tipo == "assistido"
                        ? "fourth-block"
                        : "fourth-block hyde"
                    }
                  >
                    <h2>
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.parametros"
                      )}`}
                      :
                    </h2>

                    <div className="estatistics-first-block">
                      <p>{`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.up"
                    )}`}</p>
                      <p className="first-white-group-numbers">
                        {formik.values.simulacao.valorUp
                          ? formatMoney(
                              parseFloat(formik.values.simulacao.valorUp)
                            )
                          : "0,00"}
                      </p>
                    </div>
                    <div className="estatistics-first-block">
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.taxaJurosReal"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        {formik.values.simulacao.taxaJuros
                          ? formatMoney(
                              parseFloat(formik.values.simulacao.taxaJuros)
                            )
                          : "0,00"}
                        %
                      </p>
                    </div>
                    <div className="estatistics-first-block">
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.taxaCarregamento"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        {formik.values.simulacao.taxaCarregamento
                          ? formatMoney(
                              parseFloat(
                                formik.values.simulacao.taxaCarregamento
                              )
                            )
                          : "0,00"}
                        %
                      </p>
                    </div>
                    <div className="estatistics-first-block">
                      <p>{`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.taxaAdministracao"
                      )}`}</p>
                      <p className="first-white-group-numbers">
                        {formik.values.simulacao.taxaAdministracao
                          ? formatMoney(
                              parseFloat(
                                formik.values.simulacao.taxaAdministracao
                              )
                            )
                          : "0,00"}
                        %
                      </p>
                    </div>
                  </div>
                </div>

                <div className="secound-and-third-block">
                  <div className="secound-white-block">
                    <h2>{`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.pagamentoUnico"
                    )}`}</h2>

                    <p className="spacing future">
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.definaPercentualSaldo"
                      )}`}
                    </p>

                    <div className="slidecontainer">
                      <span id="value-payment"></span>
                      <Slider
                        aria-label="Always visible"
                        defaultValue={10}
                        getAriaValueText={valuetext}
                        step={5}
                        marks
                        min={0}
                        max={25}
                        className="slider"
                        valueLabelDisplay="on"
                        value={percentualPagamentoUnico}
                        valueLabelFormat={(value) => (
                          <span className="value-payment">{value}%</span>
                        )}
                        onChange={handleSliderChange}
                        onChangeCommitted={handleSliderChangeCommitted}
                      />
                      {/* <input
                        type="range"
                        min="0"
                        max="25"
                        step="5"
                        ref={slidePagamentoUnico}
                        id="slider-payment"
                      /> */}
                      <i className="line line-1">
                        <i>0%</i>
                      </i>
                      <i className="line line-2">
                        <i>5%</i>
                      </i>
                      <i className="line line-3">
                        <i>10%</i>
                      </i>
                      <i className="line line-4">
                        <i>15%</i>
                      </i>
                      <i className="line line-5">
                        <i>20%</i>
                      </i>
                      <i className="line line-6">
                        <i>25%</i>
                      </i>
                    </div>

                    <div>
                      <div className="spacing"></div>

                      <div>
                        <p className="text-mooney">
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.valorPagamentoUnico"
                          )}`}
                          :
                          <span className="mooney">
                            <span>R$</span>{" "}
                            {formik.values.simulacao.pagamentoUnico
                              ? formatMoney(
                                  parseFloat(
                                    formik.values.simulacao.pagamentoUnico
                                  )
                                )
                              : "0,00"}
                          </span>
                        </p>
                      </div>

                      <div className="alert-icon">
                        <span className="material-icons">error_outline</span>
                        <p>
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.infoResultadoPagamentoUnico"
                          )}`}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="third-block">
                    <h2>{`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.beneficioInicialAposentadoria"
                    )}`}</h2>

                    <p className="spacing future">
                      {`${translate.t(
                        "app.tela.simulacaoPrevidenciaCDPuro.label.definaPercentualSaldo"
                      )}`}
                      :
                    </p>

                    <div className="slidecontainer">
                      <span id="value-benefit"></span>
                      <Slider
                        aria-label="Always visible"
                        defaultValue={0.1}
                        getAriaValueText={valuetext}
                        step={0.1}
                        marks
                        min={0.1}
                        max={1.5}
                        className="slider"
                        valueLabelDisplay="on"
                        value={percentualInicialAposentadoria}
                        valueLabelFormat={(value) => (
                          <span className="value-payment">{value}%</span>
                        )}
                        onBlur={formik.handleBlur}
                        onChange={handlePercentualAposentadoriaSliderChange}
                        onChangeCommitted={
                          handlePercentualAposentadoriaSliderChangeCommitted
                        }
                      />
                      {/* <input
                        type="range"
                        step="0.1"
                        min="0.1"
                        max="1.5"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.percentualInicialAposentadoria}
                        className="slider"
                        id="slider-benefit"
                      /> */}
                    </div>

                    <div>
                      <div className="spacing"></div>

                      <div>
                        <p className="text-mooney">
                          {`${translate.t(
                            "app.tela.simulacaoPrevidenciaCDPuro.label.valorParcela"
                          )}`}
                          :
                          <span className="mooney">
                            <span>R$</span>{" "}
                            {formatMoney(
                              parseFloat(formik.values.simulacao.valorBeneficio)
                            )}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={
                  formik.values.tipo == "ativo"
                    ? "group-last-two-white-blocks"
                    : "group-last-two-white-blocks hyde"
                }
              >
                <div className="fourth-block">
                  <h2>
                    {`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.parametros"
                    )}`}
                    :
                  </h2>

                  <div className="estatistics-first-block">
                    <p>{`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.up"
                    )}`}</p>
                    <p className="first-white-group-numbers">
                      {formik.values.simulacao.valorUp
                        ? formatMoney(
                            parseFloat(formik.values.simulacao.valorUp)
                          )
                        : "0,00"}
                    </p>
                  </div>
                  <div className="estatistics-first-block">
                    <p>{`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.taxaJurosReal"
                    )}`}</p>
                    <p className="first-white-group-numbers">
                      {formik.values.simulacao.taxaJuros
                        ? formatMoney(
                            parseFloat(formik.values.simulacao.taxaJuros)
                          )
                        : "0,00"}
                      %
                    </p>
                  </div>
                  <div className="estatistics-first-block">
                    <p>{`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.taxaCarregamento"
                    )}`}</p>
                    <p className="first-white-group-numbers">
                      {formik.values.simulacao.taxaCarregamento
                        ? formatMoney(
                            parseFloat(formik.values.simulacao.taxaCarregamento)
                          )
                        : "0,00"}
                      %
                    </p>
                  </div>
                  <div className="estatistics-first-block">
                    <p>{`${translate.t(
                      "app.tela.simulacaoPrevidenciaCDPuro.label.taxaAdministracao"
                    )}`}</p>
                    <p className="first-white-group-numbers">
                      {formik.values.simulacao.taxaAdministracao
                        ? formatMoney(
                            parseFloat(
                              formik.values.simulacao.taxaAdministracao
                            )
                          )
                        : "0,00"}
                      %
                    </p>
                  </div>
                </div>
                <div className="fifth-block">
                  <Chart
                    id="piechart"
                    options={options}
                    series={series}
                    type="pie"
                    width={380}
                  />
                  <div>
                    <div className="description-graphic">
                      <div className="ball-a"></div>
                      <p>
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoParticipante"
                        )}`}
                        <br />
                        <span>: </span>
                        <strong>
                          R${" "}
                          {formatMoney(
                            parseFloat(
                              formik.values.simulacao
                                .valorTotalContribuicaoParticipante
                            )
                          )}
                        </strong>
                      </p>
                    </div>

                    <div className="description-graphic">
                      <div className="ball-b"></div>
                      <p>
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.contribuicaoPatrocinadora"
                        )}`}{" "}
                        <br />
                        <span>: </span>
                        <strong>
                          R${" "}
                          {formatMoney(
                            parseFloat(
                              formik.values.simulacao
                                .valorTotalContribuicaoPatrocinadora
                            )
                          )}
                        </strong>
                      </p>
                    </div>

                    <div className="description-graphic">
                      <div className="ball-c"></div>
                      <p>
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.creditoMigracao"
                        )}`}
                        <br />
                        <span>: </span>
                        <strong>
                          R${" "}
                          {formatMoney(
                            parseFloat(formik.values.simulacao.valorMigracao)
                          )}
                        </strong>
                      </p>
                    </div>

                    <div className="description-graphic">
                      <div className="ball-d"></div>
                      <p>
                        {`${translate.t(
                          "app.tela.simulacaoPrevidenciaCDPuro.label.rentabilidade"
                        )}`}
                        <br /> <span>: </span>
                        <strong>
                          R${" "}
                          {formatMoney(
                            parseFloat(
                              formik.values.simulacao.valorRentabilidade
                            )
                          )}
                        </strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  simuladorPrevidencia: state.simuladorPrevidencia,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(Actions, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SimuladorPrevidencia);